import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import { ClassValue } from 'clsx';

@Directive({
  selector: '[cardItemActions]',
  host: {
    'data-slot': 'item-actions',
    '[class]': '_computedClass()',
  },
})
export class CardItemActions {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() => hlm('flex items-center gap-2', this.userClass()));
}
